<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        ref="tableRef"
        :tableId="'DcCosOFbuActivityCode'"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item :label="t('clue.审核状态')">
              <CosSelect
                v-model:value="queryForm.oaAuditStatus"
                :options="oaReviewStatus"
                :placeholder="t('common.pleaseSelect')"
                allowClear
                show-arrow
              />
              <!--                <a-radio-group v-model:value="queryForm.auditStatus" @change="handleQueryChange('search')">-->
              <!--                  <a-radio-button v-for="item in oaReviewStatus" :key="item.value" :value="item.value">{{-->
              <!--                      t(item.lang)-->
              <!--                    }}</a-radio-button>-->
              <!--                </a-radio-group>-->
            </dc-form-item>
            <dc-form-item name="activityName" :label="t('marketing.活动名称')">
              <a-input
                v-model:value.trim="queryForm.activityName"
                :maxlength="100"
                allowClear
                :placeholder="t('common.pleaseInput')"
              />
            </dc-form-item>
            <dc-form-item name="startTime" :label="t('marketing.活动时间')">
              <CosRangePicker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime" />
            </dc-form-item>
            <dc-form-item name="channelList" :label="t('marketing.来源渠道')">
              <ParamCodeCascader
                type="search"
                v-model:ids="queryForm.channelList"
                appId="cos_ofbu"
                :options="paramCodeData[props.paramCode]"
              />
            </dc-form-item>
            <dc-form-item name="follower" :label="t('marketing.活动负责人')">
              <UserSelect v-model:value="queryForm.follower" :placeholder="t('common.pleaseSelect')" allowClear />
            </dc-form-item>
            <dc-form-item name="enableFlag" :label="t('operate.lbczwf')">
              <a-select
                :fieldNames="{ label: 'name' }"
                v-model:value="queryForm.enableFlag"
                allowClear
                :placeholder="t('common.pleaseSelect')"
                :options="statusEnum"
              />
            </dc-form-item>
            <dc-form-item name="createBy" :label="t('common.createByName')">
              <UserSelect v-model:value="queryForm.createBy" :placeholder="t('common.pleaseSelect')" allowClear />
            </dc-form-item>
            <dc-form-item :label="t('custom.申请单号')">
              <a-input
                v-model:value="queryForm.oaApplyNo"
                :maxlength="100"
                allowClear
                :placeholder="t('common.pleaseInput')"
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'enableFlag'">
            <span :style="{color: statusEnum.find((item) => item.value === (text ? 1 : 0))?.color}">{{ statusEnum.find((item) => item.value === (text ? 1 : 0))?.name || '--' }}</span>
          </template>
          <template v-if="column.dataIndex === 'oaAuditStatus'">
            <span :style="{color: oaReviewStatus.find((item) => item.value === text)?.color}">{{ t(oaReviewStatus.find((item) => item.value === text)?.lang || '--') }}</span>

            <!-- <dc-status
              :enums="
                oaReviewStatus.map((item) => ({
                  name: t(item.lang),
                  value: item.value,
                  color: item.color
                }))
              "
              :value="text"
            /> -->
          </template>
          <template v-if="column.dataIndex === 'eventBudge'">
            <p>
              {{
                record.eventBudge
                  ? `${record.eventBudge}(${
                      paramCodeData.ofbu_currency.find((item) => item.id === record.eventBudgeCurrency)?.enName
                    })`
                  : '--'
              }}
            </p>
          </template>
          <template v-if="column.dataIndex === 'channelId'">
            <ChannelText appId="cos_ofbu" :options="paramCodeData[props.paramCode]" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'startTime'">
            <span>{{ dayjs(record.startTime).format('YYYY/MM/DD') }}-{{ dayjs(record.end).format('YYYY/MM/DD') }}</span>
          </template>
          <template v-if="column.dataIndex === 'nextReviewer'">
            <p>
              {{
                record.oaNextReviewer && record.oaNextReviewer.length > 0
                  ? record.oaNextReviewer.map((item) => item.employeeName || '--').join('、')
                  : '--'
              }}
            </p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button
                v-if="record.oaAuditStatus === '10' || record.oaAuditStatus === '11' || (record.oaAuditStatus === '30' && !record.oaApplyNo)"
                v-permission="permission.edit"
                type="link"
                @click="triggerAddOrEdit(record.id, record.oaApplyNo || record.oaAuditStatus === '10' ? 0 : 1)"
                >{{ t('btn.edit') }}</a-button
              >
              <a-button v-permission="permission.delete" type="link" @click="handleDelete(record)">{{
                t('btn.del')
              }}</a-button>
              <a-button
                v-if="record.oaAuditStatus === '10' || record.oaAuditStatus === '11'"
                v-permission="permission.delete"
                type="link"
                @click="triggerAddOrEdit(record.id, 0, 1)"
                >{{ t('btn.提交') }}</a-button
              >
              <a-button
                v-if="record.oaAuditStatus === '20'"
                v-permission="permission.withdraw"
                type="link"
                @click="handleWithdraw(record)"
                >{{ t('btn.revoke') }}</a-button
              >
              <a-button
                v-permission="permission.enable"
                v-if="!record.enableFlag && record.oaAuditStatus === '30'"
                type="link"
                @click="handleStatus(record)"
                >{{ t('marketing.可用') }}</a-button
              >
              <a-button
                v-permission="permission.disable"
                v-else-if="record.oaAuditStatus === '30'"
                type="link"
                @click="handleStatus(record)"
                >{{ t('marketing.不可用') }}</a-button
              >
              <a-button
                v-permission="permission.qrcode"
                v-if="record.oaAuditStatus === '30'"
                type="link"
                @click="showModal('zh-CN', record)"
                >{{ t('marketing.中文二维码') }}</a-button
              >
              <a-button
                v-permission="permission.qrcode"
                v-if="record.oaAuditStatus === '30'"
                type="link"
                @click="showModal('en-US', record)"
                >{{ t('marketing.英文二维码') }}</a-button
              >
            </MoreButton>
          </template>
        </template>
        <template #button>
          <a-button v-permission="permission.add_not_approved" type="primary" @click="triggerAddOrEdit(undefined, 1)">{{
            t('marketing.新增（不审核）')
          }}</a-button>
          <a-button v-permission="permission.add" type="primary" @click="triggerAddOrEdit(undefined, 0)">{{
            t('btn.add')
          }}</a-button>
        </template>
      </cos-table>

      <a-modal v-model:visible="visible" :title="qrCodeTitle" @ok="handleOk">
        <template #footer>
          <a-button key="submit" type="primary" @click="handleCopy">{{ t('marketing.复制链接') }}</a-button>
          <a-button key="submit" type="primary" @click="handleOk">{{ t('marketing.下载二维码') }}</a-button>
        </template>
        <vue-qr
          :margin="0"
          :size="400"
          :text="qrCodeUrl"
          :logoSrc="qrCodeLogoEnum[props.subdomain]"
          :logoScale="0.25"
          :logoMargin="6"
          :correctLevel="0"
          ref="qrCodeRef"
        />
      </a-modal>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, onMounted, computed, ref, unref } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import UserSelect from '@/components/UserSelect/index'
import CosRangePicker from '@/components/CosRangePicker/index'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import { downloadFileByBase64 } from '@/utils/index'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import { oaReviewStatus } from '@/views/overseasSales/commonEnum/dataConfig'
import { useI18n } from 'vue-i18n'
import { Modal as AModal } from 'ant-design-vue'
import {
  activityList,
  activityEnable,
  activityDisabled,
  activityDelete,
  partnerDropList,
  activityRetract
} from '@/api/marketing/marketingManage'
import Modal from '@/hooks/modalType'
import { ActivityCodeParams, ActivityCodeListItem } from '@/typings/api/marketingManage'
import { Item } from 'ant-design-vue/lib/menu'
const router = useRouter()
const { clipboardRef, copiedRef } = useCopyToClipboard()
const { t } = useI18n()
const props = {
  subdomain: 'ofbu',
  paramCode: 'ofbu_source_channel'
}

const permission = {
  add: 'ofbu_activity_add_btn',
  edit: 'ofbu_activity_edit_btn',
  delete: 'ofbu_activity_del_btn',
  enable: 'ofbu_activity_enable_btn',
  disable: 'ofbu_activity_disable_btn',
  qrcode: 'ofbu_activity_qrcode_btn',
  add_not_approved: 'ofbu_activity_add_not_approved_btn',
  withdraw: 'ofbu_activity_withdraw_btn',
  submit: 'ofbu_activity_submit_btn'
}

const statusEnum = computed(() => [
  { name: t('marketing.可用'), value: 1, color: '#3FAC46' },
  { name: t('marketing.不可用'), value: 0, color: '#DF443B' }
])
const tableRef = ref()
const queryForm = reactive<ActivityCodeParams>({})

const columns = computed(() => [
  {
    title: t('marketing.活动名称'),
    dataIndex: 'activityName',
    cosType: 'link',
    path: `/${props.subdomain}/activityCode/view`,
    query: ['id'],
    fixed: 'left'
  },
  { title: t('marketing.来源渠道'), dataIndex: 'channelId' },
  { title: t('marketing.活动时间'), dataIndex: 'startTime' },
  {
    title: t('marketing.获客量'),
    dataIndex: 'salesCount',
    cosType: 'link',
    path: `/${props.subdomain}/salesClue`,
    query: ['channelExplain=$activityName', 'channelId=$channelId']
  },
  { title: t('marketing.活动负责人'), dataIndex: 'followerName' },
  { title: t('marketing.活动地点'), dataIndex: 'eventAddress' },
  { title: t('marketing.活动预算'), dataIndex: 'eventBudge' },
  { title: t('common.remark'), dataIndex: 'remark' },
  { title: t('marketing.活动状态'), dataIndex: 'enableFlag' },
  { title: t('business.wwys5u'), dataIndex: 'createTime', width: 190 },
  { title: t('custom.申请单号'), dataIndex: 'oaApplyNo' },
  { title: t('custom.当前审核人'), dataIndex: 'nextReviewer' },
  { title: t('operate.moulyj'), dataIndex: 'oaAuditStatus' },
  { title: t('marketing.审核意见'), dataIndex: 'oaReviewComments' },
  { title: t('common.action'), dataIndex: 'action', width: 170, fixed: 'right' }
])
const getList = (queryForm: ActivityCodeParams, callBack: (res: any) => void) => {
  activityList(queryForm).then((res) => {
    callBack(res)
  })
}

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  [props.paramCode]: [] // 来源渠道
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [props.paramCode, 'ofbu_currency']
  }).then((res) => {
    paramCodeData.value = res.data
    console.log('paramCodeData:', paramCodeData.value)
  })
}
const partnerEnum = ref()
const getPartner = () => {
  partnerDropList().then((res) => {
    partnerEnum.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
  getPartner()
})

// 新增编辑函数
const triggerAddOrEdit = (id?: number, skipReview = 0, isSubmit = 0) => {
  if (id) {
    router.push({ path: `/${props.subdomain}/activityCode/edit`, query: { id, skipReview, isSubmit } })
  } else {
    router.push({ path: `/${props.subdomain}/activityCode/add`, query: { skipReview } })
  }
}
const handleStatus = (row: ActivityCodeListItem) => {
  const params = { activityQrcodeId: row.id }
  if (row.enableFlag) {
    activityDisabled(params).then(() => {
      message.success(t('marketing.市场活动已停用'))
      tableRef.value?.fetch()
    })
  } else {
    const isExpired = dayjs(row.endTime).valueOf() < dayjs().valueOf()
    if (!row.enableFlag && isExpired) return message.warning(t('marketing.活动已过期，无法启用'))
    activityEnable(params).then(() => {
      message.success(t('marketing.市场活动已启用'))
      tableRef.value?.fetch()
    })
  }
}
const handleDelete = (row: ActivityCodeListItem) => {
  Modal.delete({
    name: row.activityName,
    onOk() {
      activityDelete({ activityQrcodeId: row.id }).then(() => {
        message.success(t('marketing.删除市场活动成功'))
        tableRef.value?.delFetch()
      })
    }
  })
}

const handleWithdraw = (row: ActivityCodeListItem) => {
  AModal.warning({
    closable: true,
    title: t('marketing.是否撤回当前正在审核的流程？'),
    okCancel: true,
    cancelText: t('operate.jz7ejl'),
    okText: t('btn.confirm'),
    onOk() {
      activityRetract({ oaId: row.oaId }).then(() => {
        message.success(t('marketing.撤回活动成功'))
        tableRef.value?.fetch()
      })
    }
  })
}

const qrCodeRef = ref()
const qrCodeTitle = ref('')
const visible = ref<boolean>(false)
const currentRow = ref<ActivityCodeListItem>()
const qrCodeType = ref<'zh-CN' | 'en-US'>()
const qrCodeUrl = ref('')
const qrCodeLogoEnum = {
  fbu: require('@/assets/logo_gucang.png'),
  lbu: require('@/assets/logo_yuntu.png'),
  ofbu: require('@/assets/logo_ofbu.png')
}
const handleCopy = () => {
  clipboardRef.value = qrCodeUrl.value
  if (unref(copiedRef)) {
    message.success(t('marketing.市场活动链接复制成功'))
  } else {
    message.error(t('marketing.该浏览器不支持自动复制!'))
  }
}
const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
  const langEnum = { 'zh-CN': t('marketing.中文二维码'), 'en-US': t('marketing.英文二维码') }
  qrCodeType.value = lang
  qrCodeTitle.value = langEnum[lang]
  currentRow.value = row
  qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/activity?qrcodeId=${row.id}&templateId=${row.activityTemplateId}&subdomain=${props.subdomain}&lang=${lang}`
  visible.value = true
}
const handleOk = () => {
  downloadFileByBase64(
    qrCodeRef.value.imgUrl,
    `${t('marketing.二维码')}-${currentRow.value?.activityName}-${qrCodeType.value}`
  )
  visible.value = false
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuActivityCode' }
</script>

<style scoped></style>
